import React from 'react';
import Icon from '../atoms/Icon';

function TypesIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 32 29">
      <g
        fill='currentColor'
        fillRule='evenodd'
      >
        <path d="M29.5384 3.69234C29.5384 3.01207 28.9879 2.46156 28.3077 2.46156H17.2307C16.5504 2.46156 15.9999 3.01207 15.9999 3.69234V22.154C15.9999 22.8343 16.5504 23.3848 17.2307 23.3848H28.3077C28.9879 23.3848 29.5384 22.8343 29.5384 22.154V3.69234ZM32 22.154C32 24.1938 30.3474 25.8464 28.3077 25.8464H17.2307C15.1909 25.8464 13.5383 24.1938 13.5383 22.154V3.69234C13.5383 1.65259 15.1909 0 17.2307 0H28.3077C30.3474 0 32 1.65259 32 3.69234V22.154Z"/>
        <path d="M10.201 0.623705C11.8893 -0.488409 14.1559 -0.0371116 15.2876 1.63213L15.8381 2.39535L13.8404 3.83527L13.2912 3.07204L13.2755 3.05041L13.2611 3.02877C12.8884 2.462 12.1245 2.30314 11.5556 2.67781L11.5472 2.68382L3.00742 8.21271C2.44673 8.5891 2.29365 9.34682 2.66487 9.91104L12.7839 25.2778C13.1567 25.8444 13.9206 26.0033 14.4895 25.6287L17.2551 23.8054L18.6097 25.8607L15.8441 27.684C14.141 28.8058 11.8488 28.3363 10.7274 26.6311L0.608361 11.2656C-0.512438 9.56319 -0.0404762 7.27358 1.66125 6.15139L1.66967 6.14538L10.201 0.623705Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(TypesIcon);
